import { Role } from 'interfaces';
import { http, HttpResponse } from 'msw';
import { buildRole } from '../../factories';
import { canonicalRoles } from '../../factories/seeds/entities';

export const mockRoles: Role[] = canonicalRoles.map(
  (role) => buildRole<Role>(role) as Role
);

export const testRole: Role = buildRole<Role>({
  id: '1',
  name: 'Test Role',
  organizationID:
    mockRoles.find((role) => role.name === 'Org Admin')?.organizationID ?? '',
}) as Role;

export const mockRoleHandlers = [
  // mock for useListRoles()
  http.get('*/resource/role/all', () => {
    return HttpResponse.json(mockRoles);
  }),
  http.get('*/resource/role/organization', ({ request }) => {
    const url = new URL(request.url).searchParams;
    const orgID = url.get('organizationID');
    const roles = mockRoles.filter(
      (role) => role.organizationID === orgID.toString()
    );
    return HttpResponse.json(roles);
  }),
  http.post('*/resource/role', async ({ request }) => {
    const response = await request.json();
    return HttpResponse.json(response);
  }),
  http.put('*/resource/role', async ({ request }) => {
    const response = await request.json();
    return HttpResponse.json(response);
  }),
];
